module.exports = __webpack_public_path__ + "img/banner.30bf91d3.png";